<div class="scania-spinner-overlay" *ngIf="isVisible">
  <div class="scania-spinner-container">
    <div class="scania-spinner">
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="scania-logo-spinner">
        <img src="assets/img/scania-symbol.png" alt="Scania" class="logo-icon">
      </div>
    </div>
  </div>
</div>